import { atom } from 'jotai';

export const showChallengeAtom = atom<'hide' | 'login' | 'validate'>('hide');
